import template from './invite-users.html';
import controller from './invite-users.controller';
import './invite-users.scss';

let InviteUsersComponent = {
  bindings: {},
  template,
  controller
};

export default InviteUsersComponent;



// WEBPACK FOOTER //
// ./src/app/pages/invite-users/invite-users.component.js